import { Typography } from "antd"
import Card from "antd/es/card/Card"
import { I18nContext } from "contexts/I18n/I18nProvider"
import { useContext } from "react"
import './index.scss'

type HeaderProps = {
  hhid: string
}

export default function Header({ hhid }: HeaderProps) {
  const t = useContext(I18nContext)

  return (
    <div className="features-card">
      <Card>
        <div style={{display: "flex"}}>
          <Typography.Title style={{marginTop: "0.5rem"}} level={5}>Household Id</Typography.Title>
          <Typography.Text style={{marginLeft: "0.5rem", marginTop: "0.6rem"}}>{hhid || t('general.not_available')}</Typography.Text>
        </div>
      </Card>
    </div>
  )
}
